import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath, ServiceType } from '@common/enums';
import { OdataObject, ServiceStatus } from '@common/models';
import { ODataServiceFactory } from '@common/odata';
import { AbilityService } from '@common/services/auth/ability.service';
import { AuthContextService } from '@common/services/auth/auth-context.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StatisticsService {
  private readonly ability = inject(AbilityService);
  private readonly authContext = inject(AuthContextService);
  private readonly odataFactory = inject(ODataServiceFactory);
  private readonly router = inject(Router);

  private readonly backupMethods = this.odataFactory.CreateService<ServiceStatus[]>('BackupUsers');
  private readonly domainMethods = this.odataFactory.CreateService<ServiceStatus[]>('Domains');

  protected readonly authUserId = this.authContext.id;
  protected readonly authDomainId = this.authContext.domainId;

  protected readonly isAdmin = this.ability.isAdmin;

  /*
   * @returns list of problems with services (payment, storage limit)
   */
  getServiceStatus(serviceType?: ServiceType | string): Observable<ServiceStatus[]> {
    const isAdmin = this.isAdmin();
    const id = isAdmin ? this.authDomainId() : this.authUserId();
    const service$ = isAdmin ? this.domainMethods : this.backupMethods;
    let methodName = 'ServiceStatus';

    if (serviceType != null && serviceType !== '') {
      methodName += `?service=${ServiceType[serviceType]}`;
    }

    if (this.router.url.includes(RoutePath.RetentionPolicy)) {
      methodName += `&isRetentionPage=true`;
    }

    return service$.ItemProperty<OdataObject<ServiceStatus[]>>(id, methodName).pipe(map((res) => res.value));
  }
}
